import { registerOrgOverrideLoaders } from 'lib/orgOverrides';

registerOrgOverrideLoaders({
  dadeschools: () => import(
    /* webpackChunkName: "org-dadeschools" */
    './dadeschools/overrides'
  ),
});
